import type {Store} from 'vuex';
import type {RootState} from '@/types/RootState';
import {d} from '@/utils/consoleHelper.ts';


const debug: boolean = true;

export default async ({store}: { store: Store<RootState> }): Promise<boolean> => {
    d.log('%c -- MIDDLEWARE -- CHECK AUTH ✅', 'color: white;background: green; padding: 2px; font-weight: bold;');


    const userLoaded = store.getters['auth/userLoaded'];
    const token = store.getters['auth/token'];
    const user = store.getters['auth/user'];

    d.dir('userLoaded');
    d.dir(userLoaded);

    if (debug) {
        d.log('%c       \\/     ', 'color: white;background: red; padding: 2px');
        d.dir(store);
        d.dir(`userLoaded: ${userLoaded}`);
        d.dir(`token: ${token}`);
        d.dir(user);
        d.dir(user.email);

        d.table({
            userLoaded,
            token: token ?? 'No Token',
            user: user ? user.email ?? 'User Object Exists' : 'No User',
        });
        d.log('%c       /\\     ', 'color: white;background: red; padding: 2px');
    }


    if (!userLoaded && token) {
        try {
            d.log('%c Fetching user data...', 'color: yellow; font-weight: bold;');
            await store.dispatch('auth/fetchUser');
            d.log('%c ✅ User data fetched successfully!', 'color: lime; font-weight: bold;');
        } catch (error) {
            d.error('%c ❌ Error fetching user:', 'color: red; font-weight: bold;', error);
        }
    }

    return true;
}